module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/hr/ecokra.component.scss
// module id = ./src/app/reports/hr/ecokra.component.scss
// module chunks = main